export class OneTimeSecretFile {
  private objectUrl: string | null;

  constructor(content: string, private readonly filename: string) {
    const blob = new Blob([content], {type: 'text/plain;charset=utf-8'});
    this.objectUrl = URL.createObjectURL(blob);
  }

  get available(): boolean {
    return Boolean(this.objectUrl);
  }

  download(): boolean {
    if (!this.objectUrl) {
      return false;
    }
    const link = document.createElement('a');
    link.href = this.objectUrl;
    link.download = this.filename;
    link.rel = 'noopener';
    link.click();
    link.remove();
    return true;
  }

  destroy(): void {
    if (!this.objectUrl) {
      return;
    }
    URL.revokeObjectURL(this.objectUrl);
    this.objectUrl = null;
  }
}
